module.exports = __webpack_public_path__ + "img/reefoasis.b463a298.jpg";